var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "card-body",
      attrs: { role: "form" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onUpdateUserSchools($event)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", [_vm._v(_vm._s(_vm.T.profileSchool))]),
          _c("omegaup-common-typeahead", {
            attrs: {
              "existing-options": _vm.searchResultSchools,
              options: _vm.searchResultSchools,
              value: _vm.school,
              "data-school-name": ""
            },
            on: {
              "update:value": function($event) {
                _vm.school = $event
              },
              "update-existing-options": function(query) {
                return _vm.$emit("update-search-result-schools", query)
              }
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v(_vm._s(_vm.T.userEditSchoolGrade))]),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.scholarDegree,
                expression: "scholarDegree"
              }
            ],
            staticClass: "form-control",
            attrs: { "data-school-grade": "" },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.scholarDegree = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          [
            _c("option", { attrs: { value: "none" } }, [
              _vm._v(_vm._s(_vm.T.userEditNone))
            ]),
            _c("option", { attrs: { value: "early_childhood" } }, [
              _vm._v(" " + _vm._s(_vm.T.userEditEarlyChildhood) + " ")
            ]),
            _c("option", { attrs: { value: "pre_primary" } }, [
              _vm._v(_vm._s(_vm.T.userEditPrePrimary))
            ]),
            _c("option", { attrs: { value: "primary" } }, [
              _vm._v(_vm._s(_vm.T.userEditPrimary))
            ]),
            _c("option", { attrs: { value: "lower_secondary" } }, [
              _vm._v(" " + _vm._s(_vm.T.userEditLowerSecondary) + " ")
            ]),
            _c("option", { attrs: { value: "upper_secondary" } }, [
              _vm._v(" " + _vm._s(_vm.T.userEditUpperSecondary) + " ")
            ]),
            _c("option", { attrs: { value: "post_secondary" } }, [
              _vm._v(_vm._s(_vm.T.userEditPostSecondary))
            ]),
            _c("option", { attrs: { value: "tertiary" } }, [
              _vm._v(_vm._s(_vm.T.userEditTertiary))
            ]),
            _c("option", { attrs: { value: "bachelors" } }, [
              _vm._v(_vm._s(_vm.T.userEditBachelors))
            ]),
            _c("option", { attrs: { value: "master" } }, [
              _vm._v(_vm._s(_vm.T.userEditMaster))
            ]),
            _c("option", { attrs: { value: "doctorate" } }, [
              _vm._v(_vm._s(_vm.T.userEditDoctorate))
            ])
          ]
        )
      ]),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", [
            _vm._v(_vm._s(_vm.T.userEditManageSchoolsUserCurrentlyEnrolled))
          ]),
          _c("omegaup-radio-switch", {
            attrs: {
              value: _vm.isCurrentlyEnrolled,
              "selected-value": _vm.isCurrentlyEnrolled
            },
            on: {
              "update:value": function($event) {
                _vm.isCurrentlyEnrolled = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "form-group", attrs: { "data-graduation-date": "" } },
        [
          _c("label", [_vm._v(_vm._s(_vm.T.userEditGraduationDate))]),
          _c("omegaup-datepicker", {
            attrs: { required: false, enabled: !_vm.isCurrentlyEnrolled },
            model: {
              value: _vm.graduationDate,
              callback: function($$v) {
                _vm.graduationDate = $$v
              },
              expression: "graduationDate"
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "mt-3" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary mr-2",
            attrs: { type: "submit", "data-save-school-changes": "" }
          },
          [_vm._v(" " + _vm._s(_vm.T.wordsSaveChanges) + " ")]
        ),
        _c(
          "a",
          { staticClass: "btn btn-cancel", attrs: { href: "/profile/" } },
          [_vm._v(_vm._s(_vm.T.wordsCancel))]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }